<template>
  <div :class="[prefix,`${prefix}-wrap`]">
    <div class="seach-bar-container full-box">
      <div class="logo">
        <router-link to="/">
          <img
            class="logo-img"
            src="/static/img/logo.png"
            style="width:249px;height:83px;"
          />
        </router-link>
      </div>
      <div class="search-wrap">
        <div class="search-box">
          <div class="input-box">
            <Icon type="ios-search"></Icon>
            <input
              placeholder="请输入产品名称 品牌 型号 订货编码"
              class="text ui-autocomplete-input"
              v-model="currentSearchKey"
              autocomplete="off"
            />
          </div>
          <Button
            type="primary"
            size="large"
            class="search-btn"
            @click.stop="onSearchKeyChanged"
            @keyup.enter="onSearchKeyChanged"
          >
            搜 索
          </Button>
        </div>
        <div class="hot-tags">
          热门搜索：
          <span
            v-for="item in hotTags"
            :key="item"
            @click="selectHotTags(item)"
          >{{item}}</span>
        </div>
      </div>
      <div
        class="quick-order"
        @click="toQuickOrder"
      >
        <Button
          type="primary"
          ghost
          size="large"
          class="btn-quick-order"
        >
          <span class="icon iconfont iconplaceorder"></span> <span>批量询价</span>
        </Button>
      </div>
      <div class="shopping-cart">
        <Dropdown placement="bottom-end">
          <Badge
            :count="shoppingCartTotal"
            @click.native="goShoppingCart"
          >
            <Button
              type="default"
              ghost
              size="large"
              class="btn-my-cart"
            >
              <span class="icon iconfont iconcart_plus"></span> <span>我的购物车</span>
            </Button>
          </Badge>

          <DropdownMenu
            slot="list"
            :transfer='true'
            placement='left'
          >
            <div
              class="shopping-cart-nodata"
              v-if="shoppingCartTotal <= 0"
            >
              <Icon
                type="ios-cart-outline"
                class="cart-null-icon"
              ></Icon>
              <span>您的购物车空空如也</span>
              <span>赶快去选购商品吧~</span>
            </div>
            <div
              v-else
              class="shopping-cart-list"
            >
              <div
                v-for="(item,index) in shoppingCart"
                :key="index"
                class="cart-row"
              >
                <ShoppingCartItem
                  :shoppingCartInfo='item'
                  @on-change='reCaculateCartTotal'
                ></ShoppingCartItem>
              </div>
              <div
                class="submit"
                v-if="shoppingCart.length>0"
              >
                <div class="total" v-if="!IsFaceToPrice">
                  <span>合计:</span>
                  <span class="price">￥{{totalPrice | money }}</span>
                </div>
                <div class="total" v-if="IsFaceToPrice">
                  <span class="price">待定</span>
                </div>
                <div
                  class="button"
                  @click="goShoppingCart"
                >去购物车结算</div>
              </div>
            </div>
          </DropdownMenu>
        </Dropdown>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
import '@/styles/components/header/searchBar.scss';
import ShoppingCartItem from '@/components/shoppingcart/ShoppingCartItem';
// import EventBus, { EventName } from '@/utils/EventBus';
import { mapState, mapGetters, mapActions } from 'vuex';
const prefix = 'cpt-search-bar';

export default {
  name: 'SearchBar',
  inject: ['reloadBody'],
  components: {
    ShoppingCartItem
  },
  data () {
    return {
      prefix,
      currentSearchKey: '',
      hotTags: [],
      totalPrice: 0,
      rountePath: false,
      navShow: false,
      menuIndex: 0,
      isShop: false,
      IsFaceToPrice: false
    };
  },
  computed: {
    ...mapState({
      isLogged: state => state.isLogged,
      shoppingCart: state => state.shoppingCart
    }),
    ...mapGetters({
      shoppingCartTotal: 'getShoppingCartTotal'
    })
  },
  methods: {
    ...mapActions({
      getHotKeywords: 'getHotKeywords',
      getShoppingCart: 'getShoppingCart'
    }),
    toQuickOrder () {
      this.$router.push('/findProduct');
    },
    reCaculateCartTotal () {
      this.totalPrice = 0;
      this.IsFaceToPrice = false;
      for (let i = 0; i < this.shoppingCart.length; i++) {
        if (this.shoppingCart[i].Product.IsFaceToPrice) {
          this.IsFaceToPrice = true;
          return;
        }
      }
      this.shoppingCart.forEach(item => {
        this.totalPrice += item.Quantity * item.Product.Price;
      });
    },
    selectHotTags (keyword) {
      this.currentSearchKey = keyword;
      this.onSearchKeyChanged();
    },
    onSearchKeyChanged () {
      const nextPath = '/productList';
      const routerObj = {
        path: nextPath,
        query: { searchKeyword: this.currentSearchKey }
      };
      this.$router.push(routerObj);
      this.reloadBody();
    },
    outShopStyle () {
      this.isShop = false;
    },
    selectShopStyle () {
      this.isShop = true;
    },
    goShoppingCart (ev) {
      this.$router.push('/shoppingCart');
    }
  },
  watch: {
    shoppingCartTotal (val) {
      this.reCaculateCartTotal();
    }
  },
  created () {
    this.rountePath = this.$route.path;
    if (this.isLogged || this.shoppingCart.length < 0) {
      this.getShoppingCart().then(res => {
        res.Data.List.forEach(item => {
          this.price += item.Quantity * item.Product.Price;
        });
      });
    }
    this.getHotKeywords('6').then(res => {
      this.hotTags = res.Data.List;
    });
  },
  mounted () {
    this.currentSearchKey = this.$route.query.searchKeyword || '';
    this.reCaculateCartTotal();
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/header/SearchBar.vue